
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Copy, CheckCircle2 } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

interface OrderTransferInfoProps {
  orderNumber?: number;
}

export const OrderTransferInfo = ({ orderNumber }: OrderTransferInfoProps) => {
  const [copied, setCopied] = useState(false);
  const [copiedOrderNumber, setCopiedOrderNumber] = useState(false);
  const { toast } = useToast();

  const copyToClipboard = (text: string, isOrderNumber = false) => {
    navigator.clipboard.writeText(text);
    
    if (isOrderNumber) {
      setCopiedOrderNumber(true);
      setTimeout(() => setCopiedOrderNumber(false), 2000);
    } else {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
    
    toast({
      title: "Copié !",
      description: "Le numéro a été copié dans votre presse-papier",
    });
  };

  return (
    <div className="space-y-3 sm:space-y-4">
      <h3 className="font-medium text-gray-700">Coordonnées pour le virement</h3>
      <div className="bg-gray-50 p-4 sm:p-6 rounded-lg space-y-3 sm:space-y-4 border border-gray-100">
        <div className="space-y-1">
          <p className="text-base sm:text-lg font-semibold text-gray-800">Steeve Harris</p>
          <p className="text-xs sm:text-sm text-gray-500">Destinataire du virement</p>
        </div>
        
        <div className="flex items-center justify-between p-3 bg-white rounded border border-gray-200">
          <div>
            <p className="text-base sm:text-lg font-medium text-gray-800">514 605 9207</p>
            <p className="text-xs sm:text-sm text-gray-500">Numéro pour le virement</p>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="flex items-center gap-1 sm:gap-2 h-8 px-2 sm:px-3 text-xs sm:text-sm"
            onClick={() => copyToClipboard("514 605 9207")}
          >
            {copied ? (
              <CheckCircle2 className="w-3 h-3 sm:w-4 sm:h-4 text-green-600" />
            ) : (
              <Copy className="w-3 h-3 sm:w-4 sm:h-4" />
            )}
            {copied ? "Copié !" : "Copier"}
          </Button>
        </div>
        
        <div className="flex items-center justify-between p-3 bg-white rounded border border-gray-200">
          <div>
            <p className="text-base sm:text-lg font-medium text-gray-800">Commande agro</p>
            <p className="text-xs sm:text-sm text-gray-500">Question du virement</p>
          </div>
        </div>
        
        {orderNumber && (
          <div className="flex items-center justify-between p-3 bg-white rounded border border-gray-200">
            <div>
              <p className="text-base sm:text-lg font-medium text-gray-800">{orderNumber}</p>
              <p className="text-xs sm:text-sm text-gray-500">Réponse à fournir (votre n° de commande)</p>
            </div>
            <Button
              variant="outline"
              size="sm"
              className="flex items-center gap-1 sm:gap-2 h-8 px-2 sm:px-3 text-xs sm:text-sm"
              onClick={() => copyToClipboard(orderNumber.toString(), true)}
            >
              {copiedOrderNumber ? (
                <CheckCircle2 className="w-3 h-3 sm:w-4 sm:h-4 text-green-600" />
              ) : (
                <Copy className="w-3 h-3 sm:w-4 sm:h-4" />
              )}
              {copiedOrderNumber ? "Copié !" : "Copier"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
